import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';

import {
  DynamicTable,
} from 'components';

import {
  queryData,
  setAIQuery,
} from 'store/actions/appActions';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
});



class QueryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: {
        where: {
        },
       //include: [{
          //model: 'Locations',
          //where: { city: 'Chicago' }
        //}],
        limit: 25,
        offset: 0,
      },
    };
  }

  componentDidMount() {
    if (this.props.query) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.query !== prevProps.query) {
      this.fetchData();
    }
  }

  fetchData() {
    
       this.props.dispatch(queryData(this.props.query.model_name, this.props.query.query_parameters));
  }

  getColumns = () => {
    const dataRows = this.props.querydata?.rows || [];
    if (dataRows.length === 0) return [];

    const customColumnProps = {
      id:    { style: { width: 100 }, label: 'ID' },
      npi:   { label: 'NPI' },
      // Add more customizations here
    };

    return Object.keys(dataRows[0]).map((key) => ({
      label: customColumnProps[key]?.label
        || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      key,
      ...(customColumnProps[key] || {}),
    }));
  };

  render() {
    const {
      classes,
    } = this.props;

    console.log('querydata:', this.props.querydata)

    return (
      <>
        <title>Query</title>
        <div className={classes.container}>
          <DynamicTable
            header='Query Results'
             columns={this.getColumns()}
            query={this.props.query}
            data={this.props.querydata}

            onQueryChange={this.onQueryChange}
            onSave={this.onSave}
          />
        </div>
      </>
    );
  }

  onQueryChange = (query) => {
    this.props.dispatch(setAIQuery(query));
  };
}

QueryPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object,
  query: PropTypes.object,
  querydata: PropTypes.object,
};

function mapStateToProps(state) {
  // flatten count to a number if it's an array
  let querydata = state.app.querydata || { rows: [], count: 0 };
  if (Array.isArray(querydata.count) && querydata.count[0]?.count !== undefined) {
    querydata = {
      ...querydata,
      count: querydata.count[0].count
    };
  }
  return {
    query: state.app.query || {},
    querydata,
  };
}

const styled = withStyles(styles)(QueryPage);
const connected = connect(mapStateToProps)(styled);
export { connected as QueryPage };
